import ReportingGroups from './ReportingGroups'
import CollapsableCard from '../../../common/card/CollapsableCard'
// import ExpiringLicenses from './ExpiringLicenses'
import MemberCard from './MemberCard'
import LicenseCard from './LicenseCard'
import RecentUpdates from './RecentUpdates'
import { useGroupDashboardContext } from '../GroupDashboardContext'
import ReportCard from './ReportCard'
import TeamSettingCard from './TeamSettingCard'
import ExpiringLicenses from '../Licenses/Licenses/ExpiringLicenses'
import { LicenseTableProvider } from '../Licenses/context/LicenseTableContext'
import { useNavigate } from 'react-router'
import { useContext, useState } from 'react'
import { TeamContext } from "../MenuTabs/MenuTabs"

const Organization = ({ teamData }) => {
  const navigate = useNavigate()
  
  tangibleFields.event('valueChange', field => {
    if ( field.name === 'membersync_global_organization_switcher' ) {
      let currentID = field.value
      navigate(`/organization/${currentID}`)
    }
  })

  const { filtersData } = useGroupDashboardContext()

    return (
        <>
          {
            filtersData.home?.reporting_groups_visibility && teamData.show_empty_groups &&
              <CollapsableCard title={ filtersData.home?.reporting_groups_label }>
                  <ReportingGroups teamData={ teamData } />
              </CollapsableCard>
          }
          {/* <CollapsableCard collapsed={false} title={'Expiring Licenses'}>
            <ExpiringLicenses licenses={[]} />
          </CollapsableCard> */}
          {
            filtersData.home?.panel_members_visibility &&
            
            <MemberCard 
              membersCount={teamData.team_members_count} 
              teamURL={ teamData.team_area_url }
              userMembershipStatus={ teamData.current_user_membership?.membership_status }
              isAdmin={ teamData.is_user_admin }
              remainingSeats={ teamData.team_remaining_seats }
              seatCount={ teamData.team_seat_count }
              membersModalOption={ teamData.members_modal_option }
              teamType={ teamData.team_type }
            />
          }
          {
            teamData.team_type === "msynclicenses" &&
              <LicenseTableProvider>
                <ExpiringLicenses
                  teamType={teamData.team_type}
                  membersSelection={teamData?.assign_licenses_data?.selects?.members[0].choices}
                >
                </ExpiringLicenses>
              </LicenseTableProvider>
          }
          {
            filtersData.home?.panel_reports_visibility && 
            <ReportCard/>
          }
          {
            filtersData.home?.panel_settings_visibility &&
              <TeamSettingCard/>
          }
          {/* <Card>
              <LicenseCard totalSeats={teamData.team_seat_count} remainingSeats={teamData.team_remaining_seats} />
          </Card> */}
          
        {/* <div className='msync-group-dashboard-child'>
          <Card>
              <RecentUpdates recentContent={teamData.recent_updates}/>
          </Card>
        </div> */}
        </>
    )
}

export default Organization
